import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Nicole Do',
      quote: 'The flowers looked phenomenal. Especially the bridal table. Wow. Thank you so much for being a part of our special day !'
    }
  ];

  return (
    <section className="py-24 bg-neutral-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-12 pt-[50px]">
            <h2 className="text-5xl font-bold text-neutral-800 mb-4">Testimonials</h2>
          </div>

          <div className="max-w-3xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="bg-white p-10 rounded-2xl shadow-sm"
              >
                <p className="text-xl text-neutral-600 italic mb-6 leading-relaxed">
                  &ldquo;{testimonial.quote}&rdquo;
                </p>
                <p className="text-neutral-800 font-semibold text-right">
                  &mdash; {testimonial.name}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
